export const ValveErrors = {
    VALVE_ERROR: 'VALVE_ERROR',
    AUTO_SHUTOFF_DISABLED: 'AUTO_SHUTOFF_DISABLED',
    LEARNING_PERIOD: 'LEARNING_PERIOD',
    NO_ERROR: 'NO_ERROR',
    UNKNOWN: 'UNKNOWN',
    MANUAL_OVERRIDE: 'MANUAL_OVERRIDE',
    AUTO_SHUTOFF_DISABLED_AND_MANUAL_OVERRIDE: 'AUTO_SHUTOFF_DISABLED_AND_MANUAL_OVERRIDE'
}
